import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import classes from './TablaVentasDeSucursalesPorSeleccion.css';

import * as actions from '../../../../store/actions/index';
import { formatNumber, isEven } from '../../../../shared/formatNumber';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import FilterListIcon from '@material-ui/icons/FilterList';
import { IconButton, Tooltip } from '@material-ui/core';
import Table from '../../../UI/Table/Table';
import TablaVentasPorSucursalDeLaSeleccion from '../TablaVentasPorSucursalDeLaSeleccion/TablaVentasPorSucursalDeLaSeleccion';
import WrapperTablasPorSeleccionSinComparacionToExcel from '../../Ventas/WrapperTablasPorSeleccionSinComparacionToExcel/WrapperTablasPorSeleccionSinComparacionToExcel';

const TablaVentasDeSucursalesPorSeleccion = (props) => {
  const { dataSelectedId, fechaVentasDelMes } = props;

  useEffect(() => {
    if (!props[dataOptions()[dataSelectedId].stateKey].estaCargado && props.ejecucionDePagina) {
      props[dataOptions()[dataSelectedId].onLoadKey](fechaVentasDelMes.mes, fechaVentasDelMes.anio);
    }
  }, [dataSelectedId, props.ejecucionDePagina]);

  const dataOptions = (item) => {
    return {
      categoriaDeCliente: {
        title: 'Categoría de cliente',
        stateKey: 'ventasPorCategoriaDeCliente',
        onLoadKey: 'onLoadVentasPorCategoriasDeCliente'
      },
      marca: {
        title: 'Marca',
        stateKey: 'ventasPorMarca',
        onLoadKey: 'onLoadVentasPorMarca'
      },
      rubro: {
        title: 'Rubro',
        stateKey: 'ventasPorRubro',
        onLoadKey: 'onLoadVentasPorRubro'
      },
      subrubro: {
        title: 'Subrubro',
        stateKey: 'ventasPorSubrubro',
        onLoadKey: 'onLoadVentasPorSubrubro'
      },
      vendedor: {
        title: 'Vendedor',
        stateKey: 'ventasPorVendedor',
        onLoadKey: 'onLoadVentasPorVendedor'
      },
      provincia: {
        title: 'Provincia',
        stateKey: 'ventasPorProvincia',
        onLoadKey: 'onLoadVentasPorProvincia'
      },
      zona: {
        title: 'Zona',
        stateKey: 'ventasPorZona',
        onLoadKey: 'onLoadVentasPorZona'
      }
    };
  };

  const columns = [
    {
      title: dataOptions()[dataSelectedId].title,
      field: 'name',
      align: 'left',
      cellStyle: {
        fontSize: '12px',
        paddingBottom: '5px',
        paddingTop: '5px'
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      }
    },
    {
      title: `Porc. participación`,
      field: 'porcParticipacion',
      align: 'right',
      type: 'numeric',
      cellStyle: (cellData) => {
        return {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px',
          color: cellData < 0 && 'red'
        };
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      },
      render: (rowData) => `${formatNumber(rowData.porcParticipacion)}%`
    },
    {
      title: `Monto`,
      field: 'monto',
      align: 'right',
      type: 'numeric',
      cellStyle: (cellData) => {
        return {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px',
          color: cellData < 0 && 'red'
        };
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      },
      render: (rowData) => `${storageMonedaSigno()} ${formatNumber(rowData.monto)}`
    }
  ];

  const data = () => {
    return props[dataOptions()[dataSelectedId].stateKey].ventas.map((venta) => {
      return {
        id: venta.id,
        mes: venta.mes,
        anio: venta.anio,
        name: venta.nombre,
        porcParticipacion: venta.porcentajeDeParticipacion,
        monto: venta.monto
      };
    });
  };

  const tableRef = useRef();

  return (
    <div className={classes.TablaVentasDeSucursalesPorSeleccionContainer}>
      <div className={classes.TitleCard}>
        {!props[dataOptions()[dataSelectedId].stateKey].loading && (
          <WrapperTablasPorSeleccionSinComparacionToExcel
            ventas={data()}
            fecha={`${fechaVentasDelMes.mes}/${fechaVentasDelMes.anio}`}
            ventasDe={dataOptions()[dataSelectedId].title}
          />
        )}
        <Tooltip title="Ver filtros del indicador">
          <IconButton size="small" onClick={() => props.onShowFiltersModal()}>
            <FilterListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <Table
        tableRef={tableRef}
        title=""
        loading={props[dataOptions()[dataSelectedId].stateKey].loading}
        columns={columns}
        data={data()}
        noBoxShadow
        detailPanel={(rowData) => {
          return (
            <TablaVentasPorSucursalDeLaSeleccion
              dataSelectedId={dataSelectedId}
              itemExpanded={rowData}
              mes={fechaVentasDelMes.mes}
              anio={fechaVentasDelMes.anio}
            />
          );
        }}
        customOptions={{
          thirdSortClick: false,
          sorting: true,
          grouping: false,
          draggable: false,
          search: false,
          paging: false,
          toolbar: false,
          showTitle: false,
          maxBodyHeight: 430,
          rowStyle: (rowData) => ({
            color: rowData.tableData.monto < 0 && 'red',
            backgroundColor: !isEven(rowData.tableData.id) && '#f2f2f2'
          })
        }}
        tableKey={"tabla-ventas-sucursales-seleccion"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dataSelectedId: state.sucursales.dataVentasDeSucursalesPorSeleccion,

    fechaVentasDelMes: state.sucursales.fechaVentasDelMesAnioDeSucursales,

    ventasPorCategoriaDeCliente: state.sucursales.ventasDeSucursalesDelMesPorCategoriaDeCliente,

    ventasPorMarca: state.sucursales.ventasDeSucursalesDelMesPorMarcas,
    ventasPorProvincia: state.sucursales.ventasDeSucursalesDelMesPorProvincias,
    ventasPorRubro: state.sucursales.ventasDeSucursalesDelMesPorRubros,
    ventasPorSubrubro: state.sucursales.ventasDeSucursalesDelMesPorSubrubros,
    ventasPorVendedor: state.sucursales.ventasDeSucursalesDelMesPorVendedores,
    ventasPorZona: state.sucursales.ventasDeSucursalesDelMesPorZonas
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadVentasPorCategoriasDeCliente: (mes, anio) =>
      dispatch(actions.loadVentasDeSucursalesPorCategoriaDeCliente(mes, anio)),

    onLoadVentasPorMarca: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorMarca(mes, anio)),

    onLoadVentasPorRubro: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorRubro(mes, anio)),

    onLoadVentasPorSubrubro: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorSubrubro(mes, anio)),

    onLoadVentasPorVendedor: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorVendedor(mes, anio)),

    onLoadVentasPorProvincia: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorProvincia(mes, anio)),

    onLoadVentasPorZona: (mes, anio) => dispatch(actions.loadVentasDeSucursalesDelMesPorZona(mes, anio)),

    onShowFiltersModal: () =>
      dispatch(actions.showListFiltersModal(true, 'Ventas detalladas por categoría de cliente', ['venta']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaVentasDeSucursalesPorSeleccion);
